import { Line } from "../../components/Line";
import { cn } from "../../../../../lib/utils";
import { useTranslation } from "next-i18next";

export default function HeroSection() {
	const { t } = useTranslation();

	return (
		<section
			className={cn(
				"bg-no-repeat relative bg-background-02",
				[
					"bg-[url(/landings/assets/images/casos/assets/zignet/zignet-banner-mobile.png)]",
					"h-[703px] mt-20 bg-contain bg-center",
				],
				["md:bg-cover"],
				[
					"laptop:bg-[url(/landings/assets/images/casos/assets/zignet/zignet-banner.png)]",
					"laptop:h-[768px] laptop:pt-20 laptop:mt-0 laptop:bg-cover",
				],
			)}
		>
			<div className="h-full container-blog">
				<div
					className={cn(
						"z-10 relative h-full",
						["py-[16px]"],
						["laptop:pl-[32px] laptop:pt-[80px]"],
					)}
				>
					<Line />

					<img
						src="/landings/assets/images/casos/assets/zignet/zignet-logo.svg"
						alt="Zignet"
						className={cn("w-[159px] h-[72px] mt-4", [
							"laptop:mt-6 laptop:w-[220px] laptop:h-[100px]",
						])}
					/>

					<h1
						className={cn(
							"font-semibold text-[#F58220] uppercase",
							[
								"laptop:mt-8 laptop:text-[48px] laptop:leading-[64px] laptop:max-w-[864px]",
							],
							["text-[26px] leading-[35px] mt-6 max-w-[342px]"],
						)}
					>
						{t("products.zignet.hero.title")}
					</h1>

					<p
						className={cn(
							"text-white tracking-[0.05em]",
							[
								"laptop:max-w-[678px] laptop:relative laptop:text-[22px] laptop:leading-[40px] laptop:mt-8",
							],
							["text-lg leading-8 absolute bottom-0 max-w-[342px]"],
						)}
					>
						{t("products.zignet.hero.description.part1")}
						<strong className="font-semibold text-white">
							{t("products.zignet.hero.description.company")}
						</strong>
						{t("products.zignet.hero.description.part2")}
					</p>
				</div>
			</div>
		</section>
	);
}
